import { render, staticRenderFns } from "./ComputerIcon.vue?vue&type=template&id=358c38e4&"
import script from "./ComputerIcon.vue?vue&type=script&lang=js&"
export * from "./ComputerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports